import { render, staticRenderFns } from "./SGPTabsMenuVerticalComponent.vue?vue&type=template&id=b2ff98b6"
import script from "./SGPTabsMenuVerticalComponent.vue?vue&type=script&lang=js"
export * from "./SGPTabsMenuVerticalComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPTabsMenuVerticalComponent.vue?vue&type=style&index=0&id=b2ff98b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports